import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-acknowledge-dialog',
  templateUrl: './acknowledge-dialog.component.html',
  styleUrl: './acknowledge-dialog.component.scss'
})
export class AcknowledgeDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public message: string) { 
    
  }
}
